// extracted by mini-css-extract-plugin
export default {"measurer":"measurer_measurer__-iN62"};